export const FLOW_STORAGE_KEY = 'sf_public_flow_v2';
export const FLOW_SESSION_KEY = 'sf_public_flow_session';
export const FLOW_AUTH_NAME_KEY = 'sf_public_flow_auth_name';

// The storefront cart, household members and delivery details belong to whoever
// used the browser last, so sign-out wipes them.
export const clearStoredFlow = () => {
  try { localStorage.removeItem(FLOW_STORAGE_KEY); } catch { /* storage blocked */ }
  try { sessionStorage.removeItem(FLOW_AUTH_NAME_KEY); } catch { /* storage blocked */ }
};
